export default __webpack_public_path__ + "cb4163fa23c151e21e1b77ca0cef399c.svg";